import Checkbox from '@ui/components/Checkbox/Checkbox';
import Content from '@ui/components/Content/Content';
import Heading from '@ui/components/Heading/Heading';
import Radio from '@ui/components/Radio/Radio';
import styles from './Answers.module.scss';
import classNames from 'classnames';
import {
  FormCheckbox,
  FormGroup,
  FormGroupLabel,
  FormRadio,
  FormRadioGroup,
} from '@ariakit/react';
import React from 'react';
import PropTypes from 'prop-types';

const isAnsweredWrong = (answer, isCheckbox, store) => {
  const selection = store.getValue('answer');

  if (isCheckbox) {
    return selection.includes(answer);
  }

  return selection === answer;
};

const Answers = ({ answers, isAnswered, isCheckbox, questionTitle, store }) =>
  isCheckbox ? (
    <FormGroup store={store}>
      <Heading
        as={FormGroupLabel}
        className={styles.questionTitle}
        size="h5"
        store={store}
      >
        {questionTitle}
      </Heading>
      <div className={styles.answers}>
        {answers.map(({ answer, isCorrect }) => (
          <span
            className={classNames(styles.answer, {
              [styles.isAnswered]: isAnswered,
              [styles.correctAnswer]: isCorrect && isAnswered,
              [styles.wrongAnswer]:
                isAnswered &&
                !isCorrect &&
                isAnsweredWrong(answer, isCheckbox, store),
            })}
            key={answer}
          >
            <FormCheckbox
              as={Checkbox}
              disabled={isAnswered}
              label={<Content noSpacing>{answer}</Content>}
              name="answer"
              store={store}
              value={answer}
            />
          </span>
        ))}
      </div>
    </FormGroup>
  ) : (
    <FormRadioGroup store={store}>
      <Heading
        as={FormGroupLabel}
        className={styles.questionTitle}
        size="h5"
        store={store}
      >
        {questionTitle}
      </Heading>
      <div className={styles.answers}>
        {answers.map(({ answer, isCorrect }) => (
          <span
            className={classNames(styles.answer, {
              [styles.isAnswered]: isAnswered,
              [styles.correctAnswer]: isCorrect && isAnswered,
              [styles.wrongAnswer]:
                isAnswered &&
                !isCorrect &&
                isAnsweredWrong(answer, isCheckbox, store),
            })}
            key={answer}
          >
            <FormRadio
              as={Radio}
              disabled={isAnswered}
              label={<Content noSpacing>{answer}</Content>}
              name="answer"
              store={store}
              value={answer}
              variant="horizontal"
            />
          </span>
        ))}
      </div>
    </FormRadioGroup>
  );

Answers.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      isCorrect: PropTypes.bool,
    }),
  ),
  isAnswered: PropTypes.bool,
  isCheckbox: PropTypes.bool,
  questionTitle: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object,
};

export default Answers;
